var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-dialog',{attrs:{"title":_vm.title,"visible":_vm.dialogVisible,"width":"60%","before-close":_vm.handleClose},on:{"update:visible":function($event){_vm.dialogVisible=$event}}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.rawHtml)}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }